import React from "react";
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { useRestaurantConfig } from "../../utils/restaurantConfig";
import { getCurrencySymbol } from "../../helper/formatCurrency";

const OrderProductsTable = ({
  rows,
  suggestions,
  handleChange,
  handleSelectSuggestion,
  handleAddRow,
  handleSubmit,
  showSubmitButton,
  handleProductDelete,
  showDeletePopup,
  deleteIndex,
  setShowDeletePopup,
  reasons,
  selectedReasons,
  setSelectedReasons,
  selectedOrder,
  setDeleteIndex,
  activeSuggestionIndex,
  setActiveSuggestionIndex,
}) => {
  const { locale } = useRestaurantConfig();
  const currencySymbol = getCurrencySymbol(locale);

  return (
    <div style={{ overflowY: "auto", padding: "20px" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", backgroundColor: "white" }}>
        <thead>
          <tr>
            <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: 'left' }}>Product</th>
            <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: 'left' }}>Quantity</th>
            <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: 'left' }}>Price</th>
            <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: 'left' }}>TotalPrice</th>
            <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: 'left' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((product, index) => {
            // Use offerPrice if available, otherwise use price
            const finalPrice = product.offerPrice || product.price || 0;
            const totalPrice = (product.quantity * finalPrice).toFixed(2);

            return (
              <tr key={product._id || `temp-${index}`}>
                <td style={{ border: "1px solid #ddd", padding: '8px', position: 'relative' }}>
                  {product.isNew ? (
                    <>
                      <input
                        type="text"
                        value={product.productTitle}
                        onChange={(e) => {
                          setActiveSuggestionIndex(index);
                          handleChange(index, "productTitle", e.target.value);
                        }}
                        autoComplete="off"
                        style={{ width: '90%', padding: '4px' }}
                      />
                      {suggestions.length > 0 && activeSuggestionIndex === index && (

                        <ul
                          style={{
                            listStyle: "none",
                            margin: 0,
                            padding: "5px",
                            border: "1px solid #ccc",
                            backgroundColor: "white",
                            position: "absolute",
                            top: "100%",
                            left: "8px",
                            width: "calc(100% - 16px)",
                            zIndex: 10,
                            maxHeight: "150px",
                            overflowY: "auto",
                            boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
                          }}
                        >
                          {suggestions.map((item) => (
                            <li
                              key={item._id}
                              onClick={() => {
                                handleSelectSuggestion(index, item);
                                setActiveSuggestionIndex(null);
                              }}

                              style={{
                                cursor: "pointer",
                                fontSize: "14px",
                                padding: '5px',
                                borderBottom: '1px solid #eee',
                                transition: 'background-color 0.2s'
                              }}
                              onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                              onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                            >
                              {item.productName}
                            </li>
                          ))}
                        </ul>
                      )}
                    </>
                  ) : (
                    product.productTitle ? product.productTitle.split(",")[0] : 'N/A'
                  )}
                </td>
                <td style={{ border: "1px solid #ddd", padding: '8px' }}>
                  {product.isNew ? (
                    <input
                      type="number"
                      value={product.quantity}
                      onChange={(e) => handleChange(index, "quantity", e.target.value)}
                      min="1"
                      style={{ width: '60px', padding: '4px' }}
                    />
                  ) : (
                    product.quantity
                  )}
                </td>
                <td style={{ border: "1px solid #ddd", padding: '8px' }}>
                  {product.isNew ? (
                    <input
                      type="number"
                      value={finalPrice}
                      readOnly
                      style={{
                        fontFamily: "Segoe UI Symbol, Arial, sans-serif",
                        backgroundColor: "#f9f9f9",
                        cursor: "not-allowed",
                        width: '80px',
                        padding: '4px'
                      }}
                    />
                  ) : (
                    `${currencySymbol}${Number(finalPrice).toFixed(2)}`
                  )}
                </td>
                <td style={{ border: "1px solid #ddd", padding: '8px' }}>
                  {currencySymbol}
                  {totalPrice}
                </td>
                <td style={{ border: "1px solid #ddd", position: "relative", padding: '8px', textAlign: 'center' }}>
                  {!product.isNew && product.active !== false && (
                    <IconButton
                      onClick={() => {
                        if (!["out for delivery", "completed", "reject"].includes(selectedOrder.status)) {
                          setDeleteIndex(index);
                          setShowDeletePopup(true);
                        }
                      }}
                      style={{
                        color: ["out for delivery", "completed", "reject"].includes(selectedOrder.status) ? "#aaa" : "red",
                        borderRadius: "50%",
                        pointerEvents: ["out for delivery", "completed", "reject"].includes(selectedOrder.status) ? "none" : "auto",
                        cursor: ["out for delivery", "completed", "reject"].includes(selectedOrder.status) ? "not-allowed" : "pointer",
                        padding: "6px",
                        transition: "none",
                      }}
                      title={
                        ["out for delivery", "completed", "reject"].includes(selectedOrder.status)
                          ? "Deleting is disabled in this status"
                          : "Delete product"
                      }
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </td>
                {showDeletePopup && deleteIndex === index && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 999,
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "white",
                        padding: "20px",
                        borderRadius: "8px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                        width: "300px",
                        textAlign: "center",
                      }}
                    >
                      <h4>Delete Product</h4>
                      <p>Please select a reason:</p>
                      <select
                        value={selectedReasons[deleteIndex] || ""}
                        onChange={(e) =>
                          setSelectedReasons((prev) => ({
                            ...prev,
                            [deleteIndex]: e.target.value,
                          }))
                        }
                        style={{
                          width: "100%",
                          marginBottom: "10px",
                          padding: "8px",
                          borderRadius: '4px',
                          border: '1px solid #ccc'
                        }}
                      >
                        <option value="">Select Reason</option>
                        {reasons.map((reason, i) => (
                          <option key={i} value={reason}>
                            {reason}
                          </option>
                        ))}
                      </select>

                      <div style={{ display: "flex", justifyContent: "space-around", marginTop: '15px' }}>
                        <button
                          onClick={() => setShowDeletePopup(false)}
                          style={{
                            padding: "8px 15px",
                            backgroundColor: "#6c757d",
                            color: 'white',
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: '14px'
                          }}
                        >
                          Cancel
                        </button>

                        <button
                          onClick={() => {
                            handleProductDelete(deleteIndex);
                          }}
                          style={{
                            padding: "8px 15px",
                            backgroundColor: "red",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: '14px'
                          }}
                        >
                          Confirm Delete
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </tr>
            );
          })}
          {(selectedOrder?.status === "pending" || selectedOrder?.status === "accept") && (
            <tr>
              <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>
                <span
                  onClick={handleAddRow}
                  style={{
                    fontSize: "14px",
                    cursor: "pointer",
                    color: "#007bff",
                    userSelect: "none",
                    textDecoration: 'underline'
                  }}
                >
                  Add Item
                </span>
              </td>
            </tr>
          )}
          {showSubmitButton && (
            <tr>
              <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>
                <button
                  onClick={handleSubmit}
                  style={{
                    padding: "8px 16px",
                    fontSize: "16px",
                    backgroundColor: "#28a745",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Submit New Items
                </button>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default OrderProductsTable;